export function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }


export function getParams() {
      var regex = /[?&]([^=#]+)=([^&#]*)/g,
          url = window.location.href,
          params = {},
          match;
      while (match = regex.exec(url)) {
          params[match[1]] = match[2];
      }
      return params
  }



// WEBPACK FOOTER //
// ./src/components/Helper.js